export const theme = {
  colors: {
    primary: '#3498db',
    secondary: '#2ecc71',
    background: '#141B25',
    backgroundLight: '#1D2A38',
    text: '#ffffff',
    textSecondary: '#a0a0a0',
    border: '#2a3a4d',
    accent: '#9c27b0',
    error: '#e74c3c',
    success: '#2ecc71',
    warning: '#f39c12',
    darkOverlay: 'rgba(0, 0, 0, 0.7)',
    cardBackground: 'rgba(29, 42, 56, 0.8)',
    gradientStart: '#1a73e8',
    gradientEnd: '#9c27b0',
  },
  fonts: {
    main: "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Ubuntu, sans-serif",
    heading: "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Ubuntu, sans-serif",
    monospace: "'Roboto Mono', monospace",
  },
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
    '6xl': '4rem',
  },
  space: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '2.5rem',
    '3xl': '3rem',
  },
  borderRadius: {
    sm: '0.25rem',
    md: '0.5rem',
    lg: '0.75rem',
    full: '9999px',
  },
  shadows: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
    md: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)',
    lg: '0 10px 25px rgba(0, 0, 0, 0.15), 0 5px 10px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 40px rgba(0, 0, 0, 0.2)',
  },
  transitions: {
    fast: '0.1s',
    normal: '0.2s',
    slow: '0.3s',
    verySlow: '0.5s',
  },
  zIndices: {
    base: 0,
    overlay: 40,
    modal: 50,
    toast: 60,
    tooltip: 70,
  },
};

export type Theme = typeof theme;